import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { GET_URL_NEW } from '@utils/api/endpoints.ts';
import { BaseError, BaseResponse } from '@utils/types/shared/base.ts';
import { useNewAppSearchParams } from '@utils/hooks/use-new-app-search-params.ts';

export interface GroupBo {
  description: string;
  name: string;
  id: number;
  user_ids: number[];
}

export type CustomerBoGroupResponse = BaseResponse<GroupBo>;

export const useGetCustomerIamGroup = (customerId: number, groupId: number) => {
  const { searchParams } = useNewAppSearchParams();

  const offset = Number.isFinite(Number(searchParams.offset))
    ? Number(searchParams.offset)
    : 0;
  const limit = Number.isFinite(Number(searchParams.limit))
    ? Number(searchParams.limit)
    : 25;

  const sortField = (searchParams.sort as string | undefined) || undefined;
  const sortDirection =
    (searchParams.direction as 'asc' | 'desc' | undefined) || undefined;

  const qString = (searchParams.q as string | undefined) || undefined;

  const fetchCustomerGroup = async () => {
    const { customerIamGroupByCustomerAndGroupId } = GET_URL_NEW({
      offset,
      limit,
      q: qString,
      sort: sortField,
      direction: sortDirection
    });

    const url = customerIamGroupByCustomerAndGroupId(customerId, groupId);
    const { data } = await Axios.get<CustomerBoGroupResponse>(url);
    return data;
  };

  return useQuery<CustomerBoGroupResponse, AxiosError<BaseError>>(
    [
      'customerGroup',
      customerId,
      groupId,
      offset,
      limit,
      qString,
      sortField,
      sortDirection
    ],
    fetchCustomerGroup,
    {
      enabled: Boolean(customerId && groupId),
      retry: 1,
      useErrorBoundary: false
    }
  );
};
